angular.module('draganddrop', []);

angular.module('draganddrop')

.directive('draggable', function() {
  return {
    retrict: 'A',
    link: function(scope, element, attrs) {
      var el = element[0];
      el.draggable = !!attrs.draggable;

      el.addEventListener('dragstart', function(e) {
        e.stopPropagation();
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('Text', this.id);
        this.classList.add('drag');
        return false;
      }, false);

      el.addEventListener('dragend', function() {
        this.classList.remove('drag');
        return false;
      }, false);
    }
  };
})

.directive('droppable', function() {
  return {
    restrict: 'A',
    scope: {
      drop: '&',
      droppable: '='
    },
    link: function(scope, element) {

      if (!scope.droppable) {
        return;
      }

      // again we need the native object
      var el = element[0];

      el.addEventListener('dragover', function(e) {
        e.dataTransfer.dropEffect = 'move';
        e.preventDefault();
        e.stopPropagation();
        this.classList.add('over');
        return false;
      }, false);

      el.addEventListener('dragenter', function() {
        this.classList.add('over');
        return false;
      }, false);

      el.addEventListener('dragleave', function() {
        this.classList.remove('over');
        return false;
      }, false);

      el.addEventListener('drop', function(e) {

        // Stops some browsers from redirecting.
        e.stopPropagation();

        this.classList.remove('over');

        var item = document.getElementById(e.dataTransfer.getData('Text'));
        // this.appendChild(item);

        scope.childScope = angular.element(item).scope();
        // scope.drop({childScope: childScope});
        scope.$applyAsync('drop({childScope: childScope})');

        return false;
      }, false);

    }
  };
});



// WEBPACK FOOTER //
// ./src/lib/draganddrop.js